var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLinkedin = function SvgLinkedin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 11.945V18.6h-3.858v-6.21c0-1.559-.558-2.623-1.955-2.623-1.066 0-1.7.717-1.979 1.41-.102.25-.128.594-.128.942v6.48H7.22s.053-10.515 0-11.605h3.86V8.64l-.026.038h.026v-.038c.512-.79 1.428-1.917 3.477-1.917 2.54 0 4.443 1.658 4.443 5.223ZM3.184 1.4C1.864 1.4 1 2.266 1 3.405c0 1.114.839 2.006 2.133 2.006h.025c1.346 0 2.183-.892 2.183-2.006C5.316 2.265 4.504 1.4 3.184 1.4ZM1.229 18.6h3.858V6.994H1.229V18.6Z",
    fill: "currentColor"
  })));
};
export default SvgLinkedin;